import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { useSMLRouter } from '../../../../../routing/sml/hooks';
import { SMLRoutes } from '../../../../../routing/sml/SMLRoutes';
import { useOpenSongPage } from '../../../../smartLinks/catalog/song/page/useOpenSongPage';
import { SMLButton } from '../../../components/primitives/SMLButton';
import { overviewMessages } from './overviewMessages';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './Overview.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * Planned of a song with no release date (design b3): "Set a release date to plan a rollout." with
 * "Set the date in Catalog" (the Details section of the song page) and "Post now in Composer".
 */
const NoDateNoteComponent: React.FC<{ catalogItemUuid: string }> = ({ catalogItemUuid }) => {
  const intl = useIntl();
  const router = useSMLRouter();
  const openSongPage = useOpenSongPage();
  const setDate = useCallback(() => openSongPage(catalogItemUuid, 'details'), [catalogItemUuid, openSongPage]);
  const openComposer = useCallback(() => router.push(SMLRoutes.promoteComposer), [router]);

  return (
    <div className={styles.empty}>
      <b className={styles.emptyTitle}>{intl.formatMessage(overviewMessages.noDateTitle)}</b>
      <span>{intl.formatMessage(overviewMessages.noDateBody)}</span>
      <div className={styles.emptyActions}>
        <SMLButton variant="primary" onClick={setDate}>
          {intl.formatMessage(overviewMessages.setDate)}
        </SMLButton>
        <SMLButton onClick={openComposer}>{intl.formatMessage(overviewMessages.postNow)}</SMLButton>
      </div>
    </div>
  );
};

export const NoDateNote = TypedMemo(NoDateNoteComponent);
